var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_682_11143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.24527 14.0753C10.2981 14.0753 11.1516 13.2496 11.1516 12.231C11.1516 11.2124 10.2981 10.3867 9.24527 10.3867C8.19243 10.3867 7.33893 11.2124 7.33893 12.231C7.33893 13.2496 8.19243 14.0753 9.24527 14.0753Z",
    stroke: "#424450",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42552 16.8057C6.41265 16.4398 6.47602 16.0751 6.61188 15.7334C6.74773 15.3917 6.9533 15.0799 7.21631 14.8166C7.47932 14.5534 7.79441 14.344 8.14281 14.201C8.4912 14.0581 8.86577 13.9844 9.24422 13.9844C9.62267 13.9844 9.99725 14.0581 10.3456 14.201C10.694 14.344 11.0091 14.5534 11.2721 14.8166C11.5352 15.0799 11.7407 15.3917 11.8766 15.7334C12.0124 16.0751 12.0758 16.4398 12.0629 16.8057",
    stroke: "#424450",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1799 10.2886C16.9593 10.2886 18.4018 8.89309 18.4018 7.17164C18.4018 5.4502 16.9593 4.05469 15.1799 4.05469C13.4005 4.05469 11.9581 5.4502 11.9581 7.17164C11.9581 8.89309 13.4005 10.2886 15.1799 10.2886Z",
    stroke: "#424450",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2296 12.3214C11.8001 11.5043 12.6265 10.8858 13.5873 10.5569C14.5481 10.228 15.5927 10.2059 16.5674 10.494C17.5422 10.782 18.3957 11.365 19.0025 12.1572C19.6093 12.9495 19.9375 13.9091 19.9387 14.8951",
    stroke: "#424450",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74316 8.69938C7.34767 8.69938 8.64837 7.44102 8.64837 5.88875C8.64837 4.33649 7.34767 3.07812 5.74316 3.07812C4.13866 3.07812 2.83795 4.33649 2.83795 5.88875C2.83795 7.44102 4.13866 8.69938 5.74316 8.69938Z",
    stroke: "#424450",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45026 12.8466C1.44933 11.9899 1.72229 11.1539 2.23171 10.4532C2.74113 9.75247 3.46209 9.22131 4.29577 8.93253C5.12944 8.64374 6.03503 8.61145 6.88841 8.84009C7.7418 9.06872 8.50121 9.54709 9.06257 10.2096",
    stroke: "#424450",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_682_11143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.694397 0.253906)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.5959e5ec3476e1919d9ef18e7dfbb1de.svg";
export { ForwardRef as ReactComponent };